/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ValidateDealProductsQueryResponse,
  ValidateDealProductsPathParams,
  ValidateDealProducts404,
  ValidateDealProducts422,
} from '../types/ValidateDealProducts'

function getValidateDealProductsUrl({
  import_number,
}: {
  import_number: ValidateDealProductsPathParams['import_number']
}) {
  const res = {
    method: 'GET',
    url: `/api/v1/importengine/previews/v2/${import_number}/validate-deal-products/` as const,
  }
  return res
}

/**
 * @summary Validate deal product names against company products
 * {@link /api/v1/importengine/previews/v2/:import_number/validate-deal-products/}
 */
export async function validateDealProducts(
  {
    import_number,
  }: { import_number: ValidateDealProductsPathParams['import_number'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ValidateDealProductsQueryResponse,
    ResponseErrorConfig<ValidateDealProducts404 | ValidateDealProducts422>,
    unknown
  >({
    method: 'GET',
    url: getValidateDealProductsUrl({ import_number }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
